import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              最近更新
            </h2>
            <p className="text-sm text-foreground-600">最新上架的漫画章节，第一时间追更</p>
          </div>
          <Link
            to="/category/xuanhuan"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            更多更新
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestUpdates.slice(0, 9).map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-20 h-28 md:w-24 md:h-32 flex-shrink-0 overflow-hidden rounded-lg">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 非常爱漫画在线看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                    {comic.description}
                  </p>
                </div>
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {comic.tags[0]}
                  </span>
                  <span className="whitespace-nowrap">更新至 {comic.chapters.length} 话</span>
                  <span className="text-primary-600 font-medium whitespace-nowrap">{comic.updateDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}